module.exports = __webpack_public_path__ + "img/ss.2045bb4c.svg";